import { Link } from 'react-router-dom';

const heroMVs = [
  {
    id: 1,
    title: 'Flowers',
    artist: 'Miley Cyrus',
    image: 'https://readdy.ai/api/search-image?query=A%20cinematic%20wide%20shot%20of%20a%20luxurious%20vintage%20golden%20mansion%20interior%20with%20dramatic%20warm%20lighting%2C%20elegant%20chandeliers%2C%20rich%20amber%20and%20gold%20tones%2C%20cinematic%20atmosphere%2C%20soft%20glow%2C%20theatrical%20mood%2C%20high%20contrast&width=1600&height=800&seq=hero-bg-01&orientation=landscape',
    tag: 'Billboard Hot 100 冠军',
  },
];

export default function HeroBanner() {
  const hero = heroMVs[0];

  return (
    <section className="relative w-full h-[500px] md:h-[650px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={hero.image}
          alt="热门欧美MV推荐"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/70"></div>

      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-4 md:px-6">
        <span className="inline-block px-4 py-1.5 bg-accent-500 text-background-50 text-xs md:text-sm font-medium rounded-full mb-6 animate-pulse">
          今日推荐
        </span>
        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-4 tracking-tight">
          欧美MV大全
        </h1>
        <p className="text-base md:text-lg text-white/80 max-w-2xl mb-2">
          汇聚全球最新最热欧美音乐视频
        </p>
        <p className="text-sm md:text-base text-white/60 max-w-xl mb-8">
          涵盖流行、摇滚、嘻哈、电子等多种风格，在线免费观看高清欧美MV
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3">
          <Link
            to={`/article/${hero.id}`}
            className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-full transition-all duration-300 hover:scale-105 whitespace-nowrap flex items-center gap-2"
          >
            <i className="ri-play-circle-line text-lg"></i>
            观看热门MV
          </Link>
          <Link
            to="/category/pop"
            className="px-8 py-3 bg-white/10 hover:bg-white/20 text-white font-medium rounded-full backdrop-blur-sm transition-all duration-300 whitespace-nowrap border border-white/20"
          >
            浏览全部MV
          </Link>
        </div>

        <div className="flex items-center gap-8 mt-12">
          <div className="text-center">
            <p className="font-heading text-2xl md:text-3xl font-bold text-white">12+</p>
            <p className="text-xs md:text-sm text-white/60 mt-1">精选MV</p>
          </div>
          <div className="w-px h-10 bg-white/20"></div>
          <div className="text-center">
            <p className="font-heading text-2xl md:text-3xl font-bold text-white">6</p>
            <p className="text-xs md:text-sm text-white/60 mt-1">音乐风格</p>
          </div>
          <div className="w-px h-10 bg-white/20"></div>
          <div className="text-center">
            <p className="font-heading text-2xl md:text-3xl font-bold text-white">HD</p>
            <p className="text-xs md:text-sm text-white/60 mt-1">高清画质</p>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-s-line text-2xl text-white/60"></i>
      </div>
    </section>
  );
}